import './Notifications.css'
import NotifPane from "../../components/notifications/NotifPane";
import FriendsContext from '../../components/contexts/FriendsContext'
import NotificationsContext from '../../components/contexts/NotificationsContext'
// import BottomNavbar from '../../components/bottom-navbar/BottomNavbar';

function Notifications() {

   return(
       <div className="notif-content">
            <NotifPane />
            {/* <BottomNavbar /> */}
       </div>
   )
}
export default Notifications
